// 小驼峰命名
const Nav = {
  product:'Product Center',
  about_shinetech:'About Us',
  news:'News',
  collaborate:'Collaborate',
  join_us:'Join Us',
  contact_us:'Contact Us'
}
const AiChat = {
  buttonIcon:"bot_button_en.png",
  buttonText:"AI Customer Service",
  title:"Shine intelligent customer service",
  content:"Hello, I am an AI customer service based on DeepSeek, and I am looking forward to helping you answer your questions related to ShineTech products~",
  loading:"Please wait...",
  placeholder:"Please enter the question you would like to ask",
  send:"Send",

  customerForm:{
    productLabel:"Purpose",
    productPlaceholder:"Please select the Inquiry Purpose",
    phoneLabel:"Phone",
    phonePlaceholder:"Please enter your contact details",
    nameLabel:"Name",
    namePlaceholder:"Please enter your full name",
  },
}


const Contactus = {
  formTitle:"Cooperation Consulting",
  Form:{
    name:"Name",
    namePlaceholder:"Please enter your name",
    nameMaxLength:"Length cannot exceed 50 characters",
    phone:"Phone",
    phonePlaceholder:"Please enter your phone number",
    phoneMaxLength:"Phone length cannot exceed 20 characters",
    email:"Email",
    emailPlaceholder:"Please enter your email",
    emailMaxLength:"Length cannot exceed 100 characters",
    company:"Company",
    companyPlaceholder:"Please enter your company",
    companyMaxLength:"Length cannot exceed 100 characters",
    content:"Message",
    contentPlaceholder:"Please enter your message",
    contentMaxLength:"Length cannot exceed 500 characters",
    submit:"Submit",
    phoneError:"Invalid phone number format",
    submitFrequent:"Submissions too frequent, please try again in 1 minute",
    submitConfirmation:"Please confirm that all information is correct before submitting the form.",
    submitCancel:"Cancel",
    submitTitle:"Prompt",
  }
}

  // 按功能模块导出
  export default {
    Nav,
    AiChat,
    Contactus,
  }